<template>
    <div>
      <p class="text-light-grey-1 text-center mb-0 fs-13">
        By continuing, you agree to  {{ privacyPolicyIsNull ? 'SeamlessHR' : privacyPolicy.client_name }}
        <a  v-if="privacyPolicyIsNull" href="https://seamlesshr.com/privacy-security" id="privacy_policy" class="text-primary" target="_blank">
          Privacy Policy
        </a> 
        <a  v-else-if="privacyPolicy.is_external === 1" :href="privacyPolicy.external_link" class="text-primary" target="_blank">
          Privacy Policy
        </a>
        <a v-else href="/h/advanced#/privacy-policy" class="text-primary" target="_blank">
           Privacy Policy
        </a> 
      </p>
    </div>
</template>

<script>
    import AdminModel from "../../models/AdminModel"
    export default {
        name: 'ClientPrivacyPolicy',
        mixins: [AdminModel],
        data() {
            return {
                privacyPolicy: null,
            }
        },
        mounted() {
          this.AdminModel.getClientPrivacyPolicy()
            .then(r => { this.privacyPolicy = r.data })
        },
        computed: {
          privacyPolicyIsNull() {
            return this.privacyPolicy === null
          }
        }
    }
</script>